export enum PayrollTimecardFeatureFlags {
    AddNotesToInvoiceRecords = 'add-notes-to-invoice-records',
    AddUniqueNameToTheGridComponent = 'ADD_UNIQUE_NAME_TO_THE_GRID_COMPONENT',
    RemoveCallToOtherPaymentsOnTimecardsPageLoad = 'REMOVE_CALL_TO_OTHER_PAYMENTS_ON_TIMECARDS_PAGE_LOAD',
    PayBillDetailsHoursTotalsReflectingManualAdjustedHours = 'PAY_BILL_DETAILS_HOURS_TOTALS_REFLECTING_MANUAL_ADJUSTED_HOURS',
    PayBillGrossAdjustments = 'TC_PAY_BILL_GROSS_ADJUSTMENTS',
    DisplayConfirmationMessageInSavingWhenHavingManualPayOrBillDetail = 'Display_Confirmation_Message_In_Saving_When_Having_Manual_Pay_Or_Bill_Detail',
    GetStatusOfReimbursementFromReimbursementsAttestedTableToDisplayInGrid = 'GET_STATUS_OF_REIMBURSEMENT_FROM_REIMBURSEMENTSATTESTED_TABLE_TO_DISPLAY_IN_GRID',
    DisplayLocumPayrollEffectiveDatesHistory = 'nova-display-locum-payroll-effective-dates-history',
    DisplaySecondValuesInTimecardDetails = 'display-second-values-in-timecard-details',
    ImproveTimecardHistorySection = 'improve-timecard-history-section',
    RevertEffectiveDateHistoryFix = 'revert-effective-date-history-fix',
    CreateEffectiveDateForLocumsW2NonMargin = 'create-effective-dates-for-locum-w2-non-margin',
    LocumsAutoPopulatingEffectiveDateRates = 'locums-auto-populating-effective-date-rates',
    ApplyCallBackHrsForOvertimeBillingOnly = 'apply-call-back-hrs-for-overtime-billing-only',
    ColoradoWeeklyDailyOvertime = 'colorado-weekly-daily-overtime',
    ShowTimeCardNavigationPreviousNext = 'show-timecard-navigation-previous-next',
    OtherPaymentsExcludeFromBilling = 'other-payments-exclude-from-billing',
    ResyncImportBatchSelfService = 'resync-import-batch-self-service'
}
